module.exports = __webpack_public_path__ + "iPhone_8_Plus_icon.svg?4ade6e118316bc59cd5d85c4e5e9e4f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/iPhone_8_Plus_icon.svg
// module id = 229
// module chunks = 0